import type { DebtAsset, RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { debtBalance } from "../debtCalculations/balance";
import { calculateOwnership } from "../genericCalculations/ownership";
import { convertCurrency } from "../genericCalculations/convertCurrency";

export const calculateRealestatePerosnalCapital = (
  userProduct: RealestateAsset,
  debt: DebtAsset,
  currencies: {
    baseCurrency: Fiat;
    currentCurrency: Fiat;
    debtCurrency: Fiat;
  }
) => {
  const { baseCurrency, currentCurrency, debtCurrency } = currencies;
  const purchasePrice = userProduct?.purchasePrice || 0;
  const purchaceExpences = userProduct?.purchaseExpenses || 0;
  const basePurchaceExpances = convertCurrency(purchaceExpences, baseCurrency, currentCurrency);
  const basePurchacePrice = convertCurrency(purchasePrice, baseCurrency, currentCurrency);
  const purchasePriceOwnership = calculateOwnership(basePurchacePrice, userProduct?.ownership || 0);
  const debtTotalBalance = debt
    ? debtBalance(debt, { baseCurrency, currentCurrency: debtCurrency })
    : 0;

  return purchasePriceOwnership + basePurchaceExpances - debtTotalBalance;
};
